import * as React from "react";

export const MyCanvasesBigIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" fill="none" viewBox="0 0 21 23">
    <path
      stroke="#113357"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M2.91 5h13.363c.506 0 .992.246 1.35.684.358.437.559 1.03.559 1.65v9.333c0 .618-.201 1.212-.56 1.65-.357.437-.843.683-1.35.683H2.91c-.506 0-.992-.246-1.35-.683S1 17.285 1 16.667V7.333c0-.619.201-1.212.56-1.65C1.916 5.246 2.402 5 2.91 5"
    ></path>
    <path stroke="#113357" strokeLinecap="round" strokeWidth="1.7" d="M4.579 8.112v7.778"></path>
  </svg>
);
